import React, { useState } from 'react';
import { MenuItemsLanguages } from './MenuItems';
import { App } from '../App.js';
import './Dropdown.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../i18n';

function DropdownLanguage() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu clicked' : 'dropdown-menu'}
      >
        {MenuItemsLanguages.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className={item.cName}
                onClick={() => changeLanguage(item.value)}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownLanguage;
